"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var enquiryFormDataTransformer_1 = require("../service/enquiryFormDataTransformer");
var formApi_1 = require("../service/formApi");
exports.useEnquireFormData = function (componentHandleError, journeyType) {
    var _a = react_1.useState(null), formData = _a[0], setFormData = _a[1];
    var _b = react_1.useState(null), formSchema = _b[0], setFormSchema = _b[1];
    var _c = react_1.useState(null), uiSchema = _c[0], setUiSchema = _c[1];
    var _d = react_1.useState([]), requiredFields = _d[0], setRequiredFields = _d[1];
    var handleFormChange = react_1.useCallback(function (formData) {
        setFormData(formData);
    }, [formData]);
    var setRequiredFieldsOnLoad = react_1.useCallback(function (formSchema) {
        if (!formSchema) {
            return;
        }
        var required = formSchema.required || [];
        // todo: remove this when all markets sends the "termsAndConditions" as required field.
        // After removing also add the "required": ["termsAndConditions"] to enquireFormData.json
        if (required.length === 0) {
            required.push('termsAndConditions');
        }
        Object.values(formSchema.properties).forEach(function (item) { var _a; return (required = required.concat(((_a = item) === null || _a === void 0 ? void 0 : _a.required) || [])); });
        var requiredUpdated = required.map(function (el) { return (el === 'userIdType' ? 'identificationType' : el); });
        setRequiredFields(requiredUpdated);
    }, []);
    react_1.useEffect(function () {
        formApi_1.default
            .getData(journeyType)
            .then(function (response) {
            setFormSchema(response.data.jsonSchema);
            setUiSchema(response.data.uiSchema);
            setFormData(enquiryFormDataTransformer_1.default.to(response.data.formData));
            setRequiredFieldsOnLoad(response.data.jsonSchema);
        })
            .catch(componentHandleError);
    }, []);
    return { formData: formData, handleFormChange: handleFormChange, formSchema: formSchema, uiSchema: uiSchema, requiredFields: requiredFields };
};
